import type { ReactNode } from 'react'
import { Text, View } from 'react-native'
import { Check } from 'lucide-react-native'
import { colors } from '@chillout/core'
import { Button } from '@chillout/ui'

interface CashierSuccessViewProps {
  title: string
  scanNextLabel: string
  doneLabel: string
  onScanNext: () => void
  onDone: () => void
  children: ReactNode
}

export function CashierSuccessView({
  title,
  scanNextLabel,
  doneLabel,
  onScanNext,
  onDone,
  children,
}: CashierSuccessViewProps) {
  return (
    <View className="items-center px-8 py-10 gap-4">
      <View className="h-20 w-20 items-center justify-center rounded-full bg-success/10">
        <Check size={40} color={colors.success} strokeWidth={2} />
      </View>

      <Text className="text-2xl lg:text-3xl font-bold text-primary text-center mt-2">
        {title}
      </Text>

      {children}

      <View className="w-full gap-3 mt-4">
        <Button label={scanNextLabel} onPress={onScanNext} />
        <Button label={doneLabel} onPress={onDone} variant="ghost" />
      </View>
    </View>
  )
}